// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__16bWO","error":"Textarea_error__3YZj3","readonly":"Textarea_readonly__eEV0G","disabled":"Textarea_disabled__2LZlE"};